import { createHashHistory } from 'history';
import React from 'react';

// NAVIGATION
import { HashRouter as Router, Switch, Route } from 'react-router-dom';

// import history from "./utils/history";
// CONTAINERS
import Login from './containers/login';
import home from './containers/home';
import txnDetails from './containers/txnDetails';

/**
 * @name AppRouter
 * @summary Renders the application routes
 * @return {jsx} React node for the application routes
 */
const history = createHashHistory();

const AppRouter = () => (
  <Router history={history}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/home" component={home} />
        <Route path="/txn-details" component={txnDetails} />
      </Switch>
  </Router>
);
export default AppRouter;